import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=555ae97c&scoped=true&"
import script from "./UserMessages.vue?vue&type=script&lang=js&"
export * from "./UserMessages.vue?vue&type=script&lang=js&"
import style0 from "./UserMessages.vue?vue&type=style&index=0&id=555ae97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ae97c",
  null
  
)

export default component.exports